import React from "react";
import Heading from "../../common/Heading";
import { SocialIcon, SocialIconsRow } from "../intro/intro_elements";
import {
  Container,
  ContactBox,
  ContactText,
  MadeText,
} from "./contact_element";

import { introSection } from "../../data";
import PrimaryButton from "../../common/PrimaryButton";
const Contact = () => {
  return (
    <Container id="contact">
      <Heading
        heading="Contact Me"
        subheading="Do you like my work? Want to get in touch? Contact me!"
      />

      <ContactBox>
        <PrimaryButton
          text="Hire me"
          href={
            "mailto:" + introSection.email + "?subject=Hey, I want to hire you!"
          }
          // newTab={true}
        />

        <ContactText href={"mailto:" + introSection.email}>
          {introSection.email}
        </ContactText>

        <SocialIconsRow>
          {introSection.contact.map((co, i) => {
            return (
              <SocialIcon key={i} href={co.url} target="_blank">
                <img
                  src={require("../../assets/images/" + co.icon)}
                  alt={"Social"}
                ></img>
              </SocialIcon>
            );
          })}
        </SocialIconsRow>
        <MadeText>Made ⚡ by Safwan</MadeText>
      </ContactBox>
    </Container>
  );
};

export default Contact;
